"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInvoice = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _invoices = require("@module/invoices");

var _request = _interopRequireDefault(require("@package/request"));

var _utils = require("@package/utils");

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var _dialog = require("@package/dialog");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("../slice");

var createInvoice = function createInvoice(formData) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var _yield$request, data, item, count, notExit, _yield$request2, items;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на создание счета по id: ' + formData['externalId']
              });
              dispatch((0, _slice.createInvoiceRequestAction)());
              _context.next = 5;
              return (0, _request["default"])({
                url: '/invoices',
                method: 'post',
                data: {
                  type: 'Invoice',
                  externalId: formData['externalId'],
                  amount: formData['amount'],
                  currency: formData['currency'],
                  description: formData['description'],
                  shop: {
                    id: formData['shop']['id']
                  },
                  invoiceData: {
                    customerPhone: formData['phone'] ? formData['phone'].replace(/[^\d+]+/ig, '') : null,
                    customerEmail: formData['email'],
                    deliveryMethod: formData['deliveryMethod']
                  }
                }
              });

            case 5:
              _yield$request = _context.sent;
              data = _yield$request.data;
              item = null;
              count = 0;
              notExit = true;

            case 10:
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Опрос созданного счета по id: ' + data['externalId']
              });
              ++count;
              _context.next = 14;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 14:
              _context.next = 16;
              return (0, _request["default"])({
                url: "/invoices",
                method: 'get',
                params: {
                  externalId: data['externalId']
                }
              });

            case 16:
              _yield$request2 = _context.sent;
              items = _yield$request2.data;

              if (items.length > 0) {
                if (items[0]['externalId'] === data['externalId']) {
                  if (items[0]['status']['code'] === 1) {
                    notExit = false;
                    item = items[0];
                  }
                }
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context.next = 21;
                break;
              }

              throw {
                data: {
                  code: '1.1.1',
                  message: 'Превышено время ожидания'
                }
              };

            case 21:
              if (notExit) {
                _context.next = 10;
                break;
              }

            case 22:
              dispatch((0, _slice.createInvoiceRequestSuccessAction)());
              dispatch((0, _invoices.createInvoicesRequestSuccessAction)(item));
              dispatch((0, _dialog.closeDialog)('create-invoice'));

              if (formData['deliveryMethod'] === 'URL') {
                dispatch((0, _dialog.openDialog)('invoice-url-success', item));
              } else {
                dispatch(notifications.push({
                  title: "\u0421\u0447\u0435\u0442 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D",
                  content: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u2116".concat(formData['externalId']),
                  mode: 'success',
                  autoClose: true
                }));
              }

              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Счет успешно создан по id: ' + data['externalId']
              });
              _context.next = 36;
              break;

            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 33;
                break;
              }

              return _context.abrupt("return", void 0);

            case 33:
              dispatch((0, _slice.createInvoiceRequestFailAction)(_context.t0['data']));
              dispatch(notifications.pushFail(_context.t0['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при создании счета по id: ' + formData['externalId']
              });

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 29]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.createInvoice = createInvoice;